<template>
  <div class="sidebar" :class="{ collapsed: isCollapsed }">
    <div class="sidebar__sticky">
      <transition name="v">
        <p class="sidebar__p" v-if="!isCollapsed">Админ-панель</p>
      </transition>

      <div
        class="toggle-btn"
        @click="toggleCollapse"
        :aria-expanded="!isCollapsed"
        role="button"
      >
        <span v-if="isCollapsed">&gt;</span>
        <span v-else>&lt;</span>
      </div>
      <div class="sidebar__content">
	      <ul class="item-list">
	        <li
	          v-for="(item, index) in items"
	          :key="index"
	          class="item"
	          @click="selectItem(item)"
	          :class="{'item__active': side.id === item.id}"
	        >
            <Icon 
                class="show-html__svg"
                :name="item.icon"
                size="20"
              />
	          <transition name="fade">
	            <span v-if="!isCollapsed" class="title">{{ item.title }}</span>
	          </transition>
	        </li>
	      </ul>
	    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    side: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isCollapsed: false,
    };
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    selectItem(item) {
      this.$emit('select', item);
    },
  },
  watch: {
    isCollapsed () {
      this.$emit('on-collapsed', this.isCollapsed);
    }
  }
};
</script>

<style scoped>
/* контейнер сайдбара: фиксируем по высоте и ставим колонку */
.sidebar {
  position: relative;
  width: 17rem;
  min-height: calc(100vh - 3rem);
  height: -webkit-fill-available;
  display: flex;
  flex-direction: column;
  background-color: var(--blue-3);
  transition: width 0.3s ease;
  z-index: 1000;
  border-right: 1px solid rgba(0,0,0,0.06);
}

/* при сворачивании */
.sidebar.collapsed {
  width: 4rem;
}

.sidebar__sticky {
	position: sticky;
	top: 0;
	z-index: 5;
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
	background: inherit;
	flex-direction: column;
	flex-wrap: nowrap;
}

/* контент, который скроллится */
.sidebar__content {
  overflow-y: auto;
  margin-top: 3.5rem;
  width: 100%;
}

.toggle-btn {
  position: absolute;
  right: 1rem;
  top: 1rem;
  border: 0.1rem solid var(--color-0);
  border-radius: 0.5rem;
  text-align: center;
  line-height: 1rem;
  padding-bottom: 0.25rem;
  /* убрать абсолютное позиционирование — теперь в потоке sticky */
  width: 2rem;
  height: 2rem;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: bold;
}

/* иконка/список */
.item-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.item {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  gap: 0.7rem;
  cursor: pointer;
  transition: background 0.2s;
}

.item:hover {
  background-color: var(--vsbs-background);
}
.item__active {
	background-color: #222628;
}

.icon {
  font-size: 20px;
  min-width: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.title {
  white-space: nowrap;
}

/* плавные переходы */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.sidebar__p {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  position: absolute;
  left: 1rem;
  top: 1rem;
  text-wrap: nowrap;
  text-align: left;
  width: 100%;
}

.sidebar.collapsed .title {
  display: none;
}

.collapsed .item {
  justify-content: center;
}

.collapsed .toggle-btn {
  right: 0.8rem;
}

.sidebar.collapsed .sidebar__p {
  display: none;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.4s ease;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
@media (max-width: 1245px) {
  .toggle-btn, .sidebar__p {

  }
}
</style>
